class FileUploader {
  constructor(root) {
    this.root = root;
    this.productForm = document.querySelector('[is="product-form"]');
    this.input = this.root.querySelector('input[type="file"]');
    this.saveBtn = this.root.querySelector("[data-save-file]");
    this.previewContainer = this.root.querySelector("[data-file-preview]");
    this.files = []; // local state

    this.input.addEventListener("change", (e) => this.handleFiles(e));
    this.saveBtn.addEventListener("click", () => this.uploadFile());
  }

  async uploadFile() {
    const file = this.input.files[0];
    if (!file) return alert("Selecione um arquivo");

    const formData = new FormData();
    formData.append("shop_url", "astrabancos.myshopify.com");
    formData.append("option_id", "1210529");
    formData.append("element_id", "file-1");
    formData.append("file-1-1", file);

    let responseJson;

    try {
      const res = await fetch("/api/front/uploadFile", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        throw new Error(`HTTP error: ${res.status}`);
      }
      responseJson = await res.json();
    } catch (err) {
      console.warn("[UploadFile] Falling back due to error:", err);

      // fallback JSON
      responseJson = {
        success: true,
        uploadedFiles: [
          {
            name: "file-1759279832-265360960.png",
            url: "https://option.nyc3.digitaloceanspaces.com/uploads/16/file-1759279832-265360960.png",
          },
        ],
      };
    }

    if (responseJson?.success && responseJson.uploadedFiles?.length) {
      const uploaded = responseJson.uploadedFiles[0];
      console.log("[UploadFile] Uploaded:", uploaded);

      // update hidden input in product form
      let productInput = this.productForm.querySelector(
        '[action="/cart/add"] [name="properties[Customização de Banco]"]'
      );
      if (!productInput) {
        // Create the input if it doesn't exist
        productInput = document.createElement("input");
        productInput.type = "hidden";
        productInput.name = "properties[Customização de Banco]";

        this.productForm.appendChild(productInput);
      }

      if (productInput) {
        productInput.value = uploaded.url;
        document.dispatchEvent(
          new CustomEvent("product-form:customization-drawer:hide", {
            bubbles: true,
          })
        );
      }
    }
  }
  renderPreview() {
    this.previewContainer.innerHTML = ""; // reset

    this.files.forEach((file, index) => {
      const wrapper = document.createElement("div");
      wrapper.className = "file-item";

      // image preview
      if (file.type.startsWith("image/")) {
        const img = document.createElement("img");
        img.src = URL.createObjectURL(file);
        img.className = "thumb";
        wrapper.appendChild(img);
      }

      // file name
      const name = document.createElement("span");
      name.textContent = file.name;
      wrapper.appendChild(name);

      // remove button
      const removeBtn = document.createElement("button");
      removeBtn.textContent = "✕";
      removeBtn.addEventListener("click", () => {
        this.files.splice(index, 1);
        this.renderPreview();
      });
      wrapper.appendChild(removeBtn);

      this.previewContainer.appendChild(wrapper);
    });
  }
  handleFiles(e) {
    const newFiles = Array.from(e.target.files);
    this.files = [...this.files, ...newFiles]; // accumulate selected files
    this.renderPreview();
  }
}

// Inicializar
document.querySelectorAll(".ast__file-upload").forEach((el) => {
  new FileUploader(el);
});
